import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { UploadProvider } from 'context'
import StyledAdminWrapper from './StyledAdminWrapper'

const LiveClassesShow = React.lazy(() =>
  import(
    /* webpackChunkName: 'admin-live-show' */ 'components_v2/Admin/LiveClasses/Show'
  )
)

export const StyledLiveShow = ({ liveInstructors, liveClass }) => {
  return (
    <StyledAdminWrapper>
      <Suspense fallback=''>
        <UploadProvider>
          <LiveClassesShow
            liveInstructors={liveInstructors}
            initialValues={liveClass}
          />
        </UploadProvider>
      </Suspense>
    </StyledAdminWrapper>
  )
}

StyledLiveShow.propTypes = {
  liveInstructors: PropTypes.array.isRequired,
  liveClass: PropTypes.object
}

export default StyledLiveShow
